import Button from "@hudson/ui/components/FormFields/Button";
import { motion } from "framer-motion";
import useContent from "@lib/use_content";
import classNames from "classnames";

interface ContinueButtonProps {
  addon?: string;
  alignLeft?: boolean;
  className?: string;
  disabled?: boolean;
  label?: string;
  loading?: boolean;
}

function ContinueButton({
  addon,
  alignLeft = false,
  className,
  disabled,
  label,
  loading,
}: ContinueButtonProps): JSX.Element | null {
  const { data, loading: queryLoading, error } = useContent(["beContinueButton"]);

  if (error) {
    console.error(error);
    return null;
  }

  return (
    <motion.div
      layout
      className={classNames(
        className,
        { "items-end sm:items-end": !alignLeft, "items-start sm:items-start": alignLeft },
        "border-gray-200 flex flex-col sm:justify-end gap-y-6 sm:gap-y-4 ",
      )}
    >
      <Button
        addon={addon}
        disabled={disabled}
        loading={loading || queryLoading}
        className={classNames({ "sm:ml-6": !alignLeft }, "text-lg justify-end")}
      >
        {label || data?.content.beContinueButton}
      </Button>
    </motion.div>
  );
}

export default ContinueButton;
